import { instance } from "./apiClient";

export const widgetsApi = {
  getWidgets: () => instance.get("/api/widgets").then((res) => res.data),

  deleteWidget: (widgetId) =>
    instance.delete(`/api/widgets/${widgetId}`).then((res) => res.data),

  createWidget: (payload) =>
    instance.post("/api/widgets", payload).then((res) => res.data),
};
